<section id="container">
  <app-menu></app-menu>
  <section id="main-content">
    <section class="wrapper task-wrapper loading-wrapper" *ngIf="isLoadingTask">
      <i class="fa fa-circle-o-notch fa-spin fa-2x"></i>
    </section>
    <section class="wrapper task-wrapper loading-wrapper" *ngIf="!isLoadingTask && error.active">
      <div class="error">
        <div class="alert alert-danger"><h4>{{ error.title }}</h4>{{ error.message }}</div>
        <pre style="display: none">{{ error.stack }}</pre>
      </div>
    </section>
    <section class="wrapper task-wrapper" *ngIf="!isLoadingTask && !error.active">
      <div class="task-progress-wrapper">
        <app-task-progress [stage]="stage"></app-task-progress>
      </div>
      <div class="task-form-wrapper">
        <app-task-form
          [task]="task"
          [isLoadingContacts]="isLoadingContacts"
          [contacts]="contacts"
          [stage]="stage"
          [showBackButtonFirstStage]="showBackButtonFirstStage"
          [availableTags]="availableTags"
          (addDelivery)="addDelivery($event)"
          (updateDelivery)="updateDelivery($event)"
          (deleteDelivery)="deleteDelivery($event)"
          (addSchedule)="addSchedule($event)"
          (updateSchedule)="updateSchedule($event)"
          (deleteSchedule)="deleteSchedule($event)"
          (addPage)="addPage($event)"
          (updatePage)="updatePage($event)"
          (deletePage)="deletePage($event)"
          (changeStage)="onChangeState($event)"
        ></app-task-form>
      </div>
    </section>
  </section>
</section>
